//import slider from "../../slider.js";

export const navigationWrapper = {
  wrapper: null,
  create(slider) {
    // IF EXISTS RETURN
    const wrapperExists = slider.container.parentNode.classList.contains('navigation-wrapper')
    if (wrapperExists) {
      this.wrapper = slider.container.parentNode
      return
    }

    function createDiv(className) {
      const div = document.createElement("div")
      const classNames = className.split(" ")
      classNames.forEach((name) => div.classList.add(name))
      return div
    }

    this.wrapper = createDiv("navigation-wrapper")
    slider.container.parentNode.appendChild(this.wrapper)
    this.wrapper.appendChild(slider.container)
  },
  destroy() {
    const parent = this.wrapper.parentNode
    while (this.wrapper.firstChild) {
      parent.insertBefore(this.wrapper.firstChild, this.wrapper)
    }
    this.wrapper.parentNode.removeChild(this.wrapper)
  },
  add(element) {
    this.wrapper.appendChild(element)
  },
  remove(element) {
    this.wrapper.removeChild(element)
  }
}

// export function addNavigationWrapper(slider) {
//   // IF EXISTS RETURN
//
//
//   function createDiv(className) {
//     var div = document.createElement("div")
//     var classNames = className.split(" ")
//     classNames.forEach((name) => div.classList.add(name))
//     return div
//   }
//
//   let wrapper = createDiv("navigation-wrapper")
//   slider.container.parentNode.appendChild(wrapper)
//   wrapper.appendChild(slider.container)
//
//   return wrapper
// }

export function removeNavigationWrapper(wrapper) {
  // IF NOT EXISTS RETURN


  function removeElement(element) {
    element.parentNode.removeChild(element)
  }

  const parent = wrapper.parentNode
  while (wrapper.firstChild)
    parent.insertBefore(wrapper.firstChild, wrapper)
  removeElement(wrapper)
}
